export const validateEmail = () => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return {
    validator: (_: any, value: any) =>
      !value || emailPattern.test(value)
        ? Promise.resolve()
        : Promise.reject(new Error("Invalid Email ID")),
  };
};

export const validateAlphaNumericWithSpecialCharsAndLetters = () => {
  const allowedPattern = /^[\w\s!@#$%^&*(),.?":{}|<>\\[\]`~'+=/-]+$/; // Alphanumeric + space + common special characters
  const mustContainLetter = /[a-zA-Z]/;

  return {
    validator: (_: any, value: any) => {
      if (!value) {
        return Promise.reject(new Error("This field is required"));
      }

      const trimmedValue = value.trim();

      if (trimmedValue === '') {
        return Promise.reject(new Error("This field is required and cannot be empty or just spaces"));
      }

      if (!allowedPattern.test(trimmedValue)) {
        return Promise.reject(new Error("Only letters, numbers, spaces, and special characters are allowed"));
      }

      if (!mustContainLetter.test(trimmedValue)) {
        return Promise.reject(new Error("Must include at least one letter"));
      }

      return Promise.resolve();
    }
  };
};

export const validateAlphaNumericWithLettersOnly = () => {
  // Only letters, numbers, and spaces
  const allowedPattern = /^[A-Za-z0-9\s]+$/;
  const mustContainLetter = /[A-Za-z]/;

  return {
    validator: (_: any, value: any) => {
      if (typeof value !== "string") {
        return Promise.reject(new Error("Invalid input type"));
      }

      const trimmedValue = value.trim();

      if (trimmedValue === "") {
        return Promise.reject(
          new Error("This field is required and cannot be empty or just spaces")
        );
      }

      if (!allowedPattern.test(trimmedValue)) {
        return Promise.reject(
          new Error("Only letters, numbers, and spaces are allowed")
        );
      }

      if (!mustContainLetter.test(trimmedValue)) {
        return Promise.reject(new Error("Must include at least one letter"));
      }

      return Promise.resolve();
    },
  };
};

export const validateName = () => {
  const amountPattern = /^[a-zA-Z0-9 ]*$/;
  return {
    validator: (_: any, value: any) =>
      !value || amountPattern.test(value)
        ? Promise.resolve()
        : Promise.reject(new Error(`Only accept combination of alphabets and numbers`)),
  };
};

export const validateAlphaNumericWithSpecialCharsAndLettersOptional = () => {
  const allowedPattern = /^[\w\s!@#$%^&*(),.?":{}|<>\\[\]`~'+=/-]+$/; // Alphanumeric + space + common special characters
  const mustContainLetter = /[a-zA-Z]/;

  return {
    validator: (_: any, value: any) => {

      if (!value) {
        return Promise.resolve();
      }

      const trimmedValue = value.trim();

      // Allow empty or whitespace-only input (field is optional)
      if (trimmedValue === '') {
       return Promise.reject(
          new Error("This field cannot be empty or just spaces")
        );
      }

      if (!allowedPattern.test(trimmedValue)) {
        return Promise.reject(new Error("Only letters, numbers, spaces, and special characters are allowed"));
      }

      if (!mustContainLetter.test(trimmedValue)) {
        return Promise.reject(new Error("Must include at least one letter"));
      }

      return Promise.resolve(); // Valid input
    }
  };
};
